var pagination = {
	backwardText: "page précédente",
	forwardText: "page suivante",
	pageRangeText: "Page {current} sur {total}",
	itemsPerPageText: "Éléments par page",
	itemRangeText: "{start}-{end} éléments sur {total}",
	pageNumberText: "page en cours"
};
var searchPlaceholder = "Rechercher...";
var frTranslations = {
	pagination: pagination,
	searchPlaceholder: searchPlaceholder
};

export { frTranslations as default, pagination, searchPlaceholder };
